import { useLanguage } from '../LanguageContext';
import { sectorIds } from '../i18n';
import { getSectorImageUrl } from '../constants/sectorImages';

export default function SectorsSection() {
  const { t } = useLanguage();

  return (
    <section
      className="section section--sectors"
      id="sectors"
      aria-labelledby="sectors-heading"
    >
      <div className="section__head">
        <h2 id="sectors-heading">{t('sectorsSection.title')}</h2>
        <p className="section__sub">{t('sectorsSection.sub')}</p>
      </div>

      <ul className="sector-showcase">
        {sectorIds.map((sid, index) => {
          const imageUrl = getSectorImageUrl(sid);
          const title = t(`sectors.${sid}.title`);
          const reverse = index % 2 === 1;

          return (
            <li
              key={sid}
              className={`sector-showcase__row${reverse ? ' sector-showcase__row--reverse' : ''}`}
            >
              <div className="sector-showcase__content">
                <h3 className="sector-showcase__title">{title}</h3>
                <p className="sector-showcase__text">
                  {t(`sectors.${sid}.description`)}
                </p>
              </div>

              <div className="sector-showcase__media">
                {imageUrl ? (
                  <img
                    src={imageUrl}
                    alt={title}
                    className="sector-showcase__image"
                    loading="lazy"
                    decoding="async"
                  />
                ) : null}
              </div>
            </li>
          );
        })}
      </ul>
    </section>
  );
}
